class DenimFit360View {
  constructor(parent) {
    if (parent.length === 0) {
      return
    }
    this.parent = parent;
    this.init();
  }

  swiper = () => {
    let parents = this.parent;
    parents.forEach(parent => {
      let swiperImage = document.querySelector('.product-banner-slider-wrapper', parent);
      if (!swiperImage) {
        return;
      }
      var swiper = new Swiper(swiperImage, {
        slidesPerView: 1.6,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          767: {
            slidesPerView: 4.2,
            spaceBetween: 20
          }
        }
      });
    });
  }

  clickEvent = () => {
    document.addEventListener("click", (e) => {
      const target = e.target;
      const ctaClicked = target.closest(".cta-360") || target.classList.contains("cta-360");
    
      if (!ctaClicked) return;
    
      const wrapper = target.closest(".data-wrapper");
      const image = wrapper?.querySelector(".image-video-wrapper .product-image");
      const video = wrapper?.querySelector(".image-video-wrapper video");
    
      if (!wrapper || !image || !video) return;
    
      const isVideoEnabled = wrapper.classList.contains("enable-video-wrapper");
    
      wrapper.classList.toggle("enable-video-wrapper", !isVideoEnabled);
      image.classList.toggle("hide", !isVideoEnabled);
      video.classList.toggle("hide", isVideoEnabled);
    
      if (isVideoEnabled) {
        video.pause();
        video.currentTime = 0;
      } else {
        video.play();
      }
    });
    
  }

  init = () => {
    this.swiper();
    this.clickEvent();
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  new DenimFit360View(document.querySelectorAll('.denim-fit-guid-360-view-wrapper'));
}, false);